import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { accessories1, accessories2, jackets1, jackets2, jeansCargos1, jeansCargos2, jersey1, jersey2, shirtsTops1, shirtsTops2, sweatshirtsZippers1, sweatshirtsZippers2, tracksuits1, tracksuits2 } from "../../assets/images/hero";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";


export default function CategoriesCarousel() {
  const { t } = useTranslation();
  const categories = [
    {
      id: 1,
      name: "category-carousel.tracksuits",
      image: [
        tracksuits1,
        tracksuits2,
      ]
    },
    {
      id: 2,
      name: "category-carousel.sweatshirts",
      image: [
        sweatshirtsZippers1,
        sweatshirtsZippers2,
      ]
    },
    {
      id: 3,
      name: "category-carousel.jackets",
      image: [
        jackets1,
        jackets2,
      ]
    },
    {
      id: 4,
      name: "category-carousel.jeans",
      image: [
        jeansCargos1,
        jeansCargos2,
      ]
    },
    {
      id: 5,
      name: "category-carousel.shirts",
      image: [
        shirtsTops1,
        shirtsTops2,
      ]
    },
    {
      id: 6,
      name: "category-carousel.jerseys",
      image: [
        jersey1,
        jersey2,
      ]
    },
    {
      id: 7,
      name: "category-carousel.accessories",
      image: [
        accessories1,
        accessories2,
      ]
    },
  ];

  return (
    <div className="container mx-auto pb-12 sm:pb-16 lg:pb-20 max-sm:px-4">
      <div className="mb-4">
        <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl">{t("categories")}</h2>
        <p className="text-base text-gray-600">{t("our-products-categories")}</p>
      </div>

      <div className="flex items-center justify-center w-full h-full">
        {/* Carousel for desktop and large size devices */}
        <CarouselProvider isPlaying={true} className="lg:block hidden" naturalSlideWidth={100} isIntrinsicHeight={true} totalSlides={7} visibleSlides={4} step={1} infinite={true}>
          <div className="w-full relative flex items-center justify-center">
            <ButtonBack role="button" aria-label="slide backward" className="absolute z-10 left-0 ml-2 focus:outline-none focus:ring-gray-400 cursor-pointer" id="prev">
              <ChevronLeftIcon className="size-6 text-white" />
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="h-full flex gap-1 items-center justify-start transition ease-out duration-700">
                  {
                    categories.map((item, index) => (
                      <Slide key={index}>
                        <a href={`/shop?category=${item.id}`} className="group flex flex-shrink-0 relative w-full sm:w-auto">
                          {/* First image */}
                          <img loading="lazy"  src={item.image[0]} alt={item.name} className="object-cover object-center w-full absolute inset-0 opacity-100 group-hover:opacity-0 transition-opacity duration-300 ease-in-out" />
                          {/* Second image */}
                          <img loading="lazy"  src={item.image[1]} alt={item.name} className="object-cover object-center w-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out" />
                          <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                            <h2 className="text-4xl font-josefin-sans leading-4 lg:leading-5 text-white">{index + 1}</h2>
                            <div className="flex h-full items-end pb-6">
                              <h3 className="text-xl lg:text-2xl font-medium leading-5 lg:leading-6 text-white">{t(item.name)}</h3>
                            </div>
                          </div>
                        </a>
                      </Slide>
                    ))}
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute z-10 right-0 mr-2 focus:outline-none focus:ring-gray-400" id="next">
              <ChevronRightIcon className="size-6 text-white" />
            </ButtonNext>
          </div>
        </CarouselProvider>

        {/* Carousel for tablet and medium size devices */}
        <CarouselProvider isPlaying={true} className="lg:hidden md:block hidden" naturalSlideWidth={100} isIntrinsicHeight={true} totalSlides={7} visibleSlides={3} step={1} infinite={true}>
          <div className="w-full relative flex items-center justify-center">
            <ButtonBack role="button" aria-label="slide backward" className="absolute z-10 left-0 ml-2 focus:outline-none focus:ring-gray-400 cursor-pointer" id="prev">
              <ChevronLeftIcon className="size-6 text-white" />
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="h-full flex gap-1 items-center justify-start transition ease-out duration-700">
                  {
                    categories.map((item, index) => (
                      <Slide key={index}>
                        <a href={`/shop?category=${item.id}`} className="flex flex-shrink-0 relative w-full sm:w-auto">
                          <img loading="lazy"  src={item.image[0]} alt={item.name} className="object-cover object-center w-full" />
                          <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                            <h2 className="text-4xl font-josefin-sans leading-4 lg:leading-5 text-white">{index + 1}</h2>
                            <div className="flex h-full items-end pb-6">
                              <h3 className="text-2xl font-medium leading-5 lg:leading-6 text-white">{t(item.name)}</h3>
                            </div>
                          </div>
                        </a>
                      </Slide>
                    ))}
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute z-10 right-0 mr-2 focus:outline-none focus:ring-gray-400" id="next">
              <ChevronRightIcon className="size-6 text-white" />
            </ButtonNext>
          </div>
        </CarouselProvider>

        {/* Carousel for mobile and Small size Devices */}
        <CarouselProvider isPlaying={true} className="block md:hidden " naturalSlideWidth={100} isIntrinsicHeight={true} totalSlides={7} visibleSlides={1} step={1} infinite={true}>
          <div className="w-full relative flex items-center justify-center">
            <ButtonBack role="button" aria-label="slide backward" className="absolute z-10 left-0 ml-2 focus:outline-none focus:ring-gray-400 cursor-pointer" id="prev">
              <ChevronLeftIcon className="size-5 text-white" />
            </ButtonBack>
            <div className="w-full h-full mx-auto overflow-x-hidden overflow-y-hidden">
              <Slider>
                <div id="slider" className="h-full w-full flex gap-1 items-center justify-start transition ease-out duration-700">
                  {
                    categories.map((item, index) => (
                      <Slide key={index}>
                        <a href={`/shop?category=${item.id}`} className="flex flex-shrink-0 relative w-full sm:w-auto">
                          <img loading="lazy"  src={item.image[0]} alt={item.name} className="object-cover object-center w-full" />
                          <div className="bg-gray-800 bg-opacity-30 absolute w-full h-full p-6">
                            <h2 className="text-4xl font-josefin-sans leading-4 lg:leading-5 text-white">{index + 1}</h2>
                            <div className="flex h-full items-end pb-6">
                              <h3 className="text-2xl font-medium leading-5 lg:leading-6 text-white">{t(item.name)}</h3>
                            </div>
                          </div>
                        </a>
                      </Slide>
                    ))}
                </div>
              </Slider>
            </div>
            <ButtonNext role="button" aria-label="slide forward" className="absolute z-10 right-0 mr-2 focus:outline-none focus:ring-gray-400" id="next">
              <ChevronRightIcon className="size-5 text-white" />
            </ButtonNext>
          </div>
        </CarouselProvider>
      </div>
    </div>
  );
}
